import React from 'react'
import useSearch from '../../../context/search/useSearch';

interface ISearchInputComponent {
  dataSet: DOMStringMap
}

const SearchInput: React.FC<ISearchInputComponent> = ({dataSet}): JSX.Element => {

  const { langSearchInputPlaceholder } = dataSet

  const {quickSearchTerm, inputEventHandlers, setQuickSearchTerm, isSearching} = useSearch()

  const handleKeyDown = (e) => {
    inputEventHandlers.handleSearchInputKeyPress(e)
  }

  const handleOnChange = (e) => {
    inputEventHandlers.handleSearchInputChange(e)
  }

  return (
    <React.Fragment>
      <div className={'sf-search-input-container'}>
        <input
          className={'sf-search-input'}
          id={'sf-search-input'}
          type="text"
          placeholder={langSearchInputPlaceholder}
          value={quickSearchTerm}
          onKeyDown={handleKeyDown}
          onChange={handleOnChange}
        />
        <input type="hidden" name="type" value="product" />
        {isSearching && <div className={'sf-is-searching'}></div>}
        {quickSearchTerm && quickSearchTerm.length && !isSearching &&
          <button
            onClick={(e) => {
              setQuickSearchTerm('')
              handleOnChange(e)
            }}
            className={'sf-clear'}
          >Clear</button>}
      </div>
    </React.Fragment>
  )
};

export default SearchInput